import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'ces-general-info-skeleton',
  standalone: true,
  imports: [SkeletonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './general-info-skeleton.component.html',
  styleUrl: './general-info-skeleton.component.scss',
})
export class CesGeneralInfoSkeletonComponent {
  @Input() skeletonCount = 6;
  @Input() gap = 4;

  get skeletonItems(): number[] {
    return Array.from({ length: this.skeletonCount }, (_, index) => index);
  }

  get gapClass(): string {
    const gapMap: Record<number, string> = {
      0: 'gap-0',
      1: 'gap-(--gap-tight)',
      2: 'gap-(--gap-normal)',
      3: 'gap-(--gap-normal)',
      4: 'gap-(--gap-relaxed)',
      6: 'gap-(--gap-loose)',
      8: 'gap-(--gap-loose)',
    };
    return gapMap[this.gap] ?? 'gap-(--gap-normal)';
  }

  getSkeletonOpacity(index: number): number {
    return 1 - index / Math.max(this.skeletonCount - 1, 1);
  }
}
